<template>
  <div>
    <title>基本信息</title>
    <section class="mainDet" v-loading="isLoad">
      <!--S 公用头部切换-->
      <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
      <!--E 公用头部切换-->
      <!--S 基本信息表单-->
      <el-form ref="checkForm" :model="checkForm" :rules="rules" label-width="125px" class="comForm" :disabled="operate == 'detail'">
        <el-row class="mainWrap widthAuto">
          <!--S 基本信息-->
          <el-col :span="11">
            <p class="commonTit"><b>基本信息</b></p>
            <el-form-item label="企业微门店名称" prop="flowname"> 
              <el-input v-model="checkForm.flowname" maxlength="20" @blur="checkFlowname" clearable placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="服务状态">
              <el-switch :value="checkForm.status ? true : false" @change="statusChange" :width="45" class="isSwitch" :active-text="checkForm.status?'启':'禁'"></el-switch>
            </el-form-item>
            <el-form-item label="地址" prop="pcdinfo">
              <ProvincesOrCity v-model="checkForm.pcdinfo" :valueType="'nv'" :level="2" :initCode="'0'" :placeholder="'请选择省市区'"></ProvincesOrCity>
            </el-form-item>
            <el-form-item label=" " prop="addrdet">
              <el-input type="textarea" v-model="checkForm.addrdet" placeholder="输入详细地址，如门牌号，不少于5个字" clearable maxlength="50" minlength="5" show-word-limit></el-input>
            </el-form-item>
            <template v-if="ElementControls('erjimendian')==1">
              <el-form-item label="联系人" prop="linkman"> 
                <el-input v-model="checkForm.linkman" maxlength="20" clearable placeholder="请输入联系人姓名"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="mobile" class="defineRow"> 
                <el-input v-model="checkForm.mobile" maxlength="11" clearable placeholder="请输入手机号码"></el-input>
                <div class="btnRight">
                  <span class="kuang"></span>
                  <em>至少填写一个</em>
                </div>
              </el-form-item>
              <el-form-item label="固话号码" prop="tel"> 
                <el-input v-model="checkForm.tel" maxlength="20" clearable placeholder="请输入固话号码"></el-input>
              </el-form-item>   
              <el-form-item> 
                <span :class="['expandTarget icondown',{'on':otherSetting}]" @click="otherSetting = !otherSetting">{{otherSetting?'点击收缩':'点击填写'}} <b>其他信息</b></span>
              </el-form-item>
              <div :class="['otherSetInfo',{'expanded':otherSetting}]">
                <el-form-item label="性别">
                  <el-radio-group v-model="checkForm.sex">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label="1">女</el-radio>
                    <el-radio :label="2">保密</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="生日">
                  <el-date-picker type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="checkForm.birthday"></el-date-picker>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email"> 
                  <el-input v-model="checkForm.email" maxlength="50" clearable placeholder="请输入电子邮箱"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="checkForm.memo" clearable placeholder="请输入备注" maxlength="100" show-word-limit></el-input>
                </el-form-item> 
              </div>
            </template>
          </el-col>
          <!--E 基本信息-->
          <el-col :span="11" :offset="2" v-if="ElementControls('erjimendian') !=1">
            <p class="commonTit"><b>联系人</b></p>
            <el-form-item label="联系人" prop="linkman"> 
              <el-input v-model="checkForm.linkman" maxlength="20" clearable placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile" class="defineRow"> 
              <el-input v-model="checkForm.mobile" maxlength="11" clearable placeholder="请输入手机号码"></el-input>
              <div class="btnRight">
                <span class="kuang"></span>
                <em>至少填写一个</em>
              </div>
            </el-form-item>
            <el-form-item label="固话号码" prop="tel"> 
              <el-input v-model="checkForm.tel" maxlength="20" clearable placeholder="请输入固话号码"></el-input>
            </el-form-item>   
            <el-form-item> 
              <span :class="['expandTarget icondown',{'on':otherSetting}]" @click="otherSetting = !otherSetting">{{otherSetting?'点击收缩':'点击填写'}} <b>其他信息</b></span>
            </el-form-item>
            <div :class="['otherSetInfo',{'expanded':otherSetting}]">
              <el-form-item label="性别">
                <el-radio-group v-model="checkForm.sex">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                  <el-radio :label="2">保密</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生日">
                <el-date-picker type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="checkForm.birthday"></el-date-picker>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email"> 
                <el-input v-model="checkForm.email" maxlength="50" clearable placeholder="请输入电子邮箱"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="checkForm.memo" clearable placeholder="请输入备注" maxlength="100" show-word-limit></el-input>
              </el-form-item> 
            </div>
          </el-col>
          <el-col :span="11" :offset="2" v-else>
            <p class="commonTit"><b>权限设置</b></p>
            <div class="powerLine flexBet" v-if="userInfoMd.cardpower || userInfoMd.exppower">
              <p>
                <el-button v-if="operate != 'detail'" type="primary" plain size="small" @click="linkAllStores(9)">{{linkedStoreList.length>0?'更改绑定门店':'绑定门店'}}</el-button>
                <em class="storeEm" v-show="linkedStoreList.length>0">已选择<b class="commonNum">{{linkedStoreList.length}}</b>家门店</em>
                <small class="iconbulb greyColor" v-if="operate != 'detail' && linkedStoreList.length == 0">想要解锁 <i class="orangeColor">激活</i> 和 <i class="orangeColor">发货</i> 权限，请先为当前微门店 <span class="mainColor cursorHand" @click="linkAllStores(9)">绑定门店</span></small>
              </p>
              <span v-if="operate != 'detail' && linkedStoreList.length>0" class="redColor cursorHand" @click="deleteAll">一键清空</span>
            </div>
            <div class="powerLine greyColor" v-else>
              <el-button type="info" disabled size="small">绑定门店</el-button>
              <small class="iconbulb">当前所属一级门店未开通 <i class="orangeColor">券卡</i> 和 <i class="orangeColor">发货</i> 权限，请联系总部！</small>
            </div>
            <el-table v-show="linkedStoreList.length>0" class="comTable storeTable" border :data="linkedStoreList" maxHeight="450" :row-class-name="tableRowClassName">
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="门店名称" min-width="200">
                <template slot-scope="scope">
                  <div class="storeInfo flexUpDownCenter">
                    <a href="javascript:;">
                      <img v-if="scope.row.mainpiclink" :src="scope.row.mainpiclink">
                      <img v-else src="https://presale.jhtsoft.com/picms/c47499b67d489.png">
                      <em class="obliqueLabel" v-if="scope.row.flowcode == userInfoMd.flowcode">当前门店</em>
                    </a>
                    <div>
                      <p class="textHiden" :title="scope.row.flowname">{{scope.row.flowname}}</p>
                      <small class="greyColor textHiden" v-if="scope.row.deliverymicrostorename" :title="scope.row.deliverymicrostorename">发货微门店：{{scope.row.deliverymicrostorename}}</small>
                      <el-tag type="success" plain v-if="scope.row.havedelivery == 1">发货</el-tag><!--当前微门店发货-->
                      <el-tag type="danger" plain v-if="!scope.row.status">已禁用</el-tag>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="联系人" min-width="150">
                <template slot-scope="scope">
                  <p class="textHiden">{{scope.row.linkman}}</p>
                  <em class="greyColor commonNum">{{scope.row.mobile || scope.row.tel}}</em>
                </template>
              </el-table-column>
              <el-table-column label="详细地址"  min-width="180">
                <template slot-scope="scope">
                  <div class="flexUpDownCenter addDetail">
                    <i class="icondw"></i>
                    <p>
                      <em class="textHiden" :title="scope.row.province +scope.row.city+ scope.row.district">{{scope.row.province}} {{scope.row.city}} {{scope.row.district}}</em>
                      <span class="textHiden" :title="scope.row.addrdet">{{scope.row.addrdet}}</span>
                    </p>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="状态" min-width="100">
                <template slot-scope="scope">
                  <el-switch :value="scope.row.status" :active-value="1" :inactive-value="0" disabled class="isSwitch" :width="45" :active-text="scope.row.status?'启':'禁'"></el-switch>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" width="60" fixed="right" v-if="operate != 'detail'">
                <template slot-scope="scope">
                    <p class="handle">
                      <span title="移除" @click="deleteStore(scope.row.flowcode,scope.$index)"><i class="icondel"></i></span>
                    </p>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="noData"><span>暂无数据</span></div>
              </template>
            </el-table>
            <p class="powerLine mlineBox">
              <el-checkbox v-model="checkForm.cardpower" :true-label="1" :false-label="0" :disabled="(userInfoMd.cardpower != 1 && checkForm.cardpower != 1) || (userInfoMd.cardpower == 1 && linkedStoreList.length==0 && checkForm.cardpower != 1)">激活</el-checkbox>
              <el-checkbox v-model="checkForm.orderpower" :true-label="1" :false-label="0" :disabled="userInfoMd.cardpower != 1 && checkForm.orderpower != 1">核销</el-checkbox>
            </p>
            <div class="bannerBg">
              <p class="pb10">
                <el-checkbox v-model="checkForm.exppower" :disabled="(userInfoMd.exppower != 1 && checkForm.exppower != 1) || (userInfoMd.exppower ==1 && linkedStoreList.length==0  && checkForm.exppower != 1)" :true-label="1" :false-label="0">发货</el-checkbox>
                <template v-if="userInfoMd.exppower == 1">
                  <template v-if="operate != 'detail' && checkForm.exppower">
                    <el-button v-if="linkedStoreList.length>0" :type="checkForm.exppower && !(selectedDeliveryStore && selectedDeliveryStore.flowcode)?'danger':'primary'" plain size="small" @click="linkAllStores(100)">{{selectedDeliveryStore && selectedDeliveryStore.flowcode?'更改发货门店':'选择发货门店'}}</el-button>
                    <template v-else>
                      <el-button type="info" disabled size="small">选择发货门店</el-button>
                      <small class="iconbulb orangeColor">选择发货门店前，请先为当前微门店 <span class="mainColor cursorHand" @click="linkAllStores(9)">绑定门店</span></small>
                    </template>
                  </template>
                  <small v-if="linkedStoreList.length>0 && checkForm.exppower && !(selectedDeliveryStore && selectedDeliveryStore.flowcode)" class="iconbulb redColor">已勾选发货权限，请选择需要发货服务的门店！</small>
                </template>
              </p>
              <div class="storeInfo flexUpDownCenter" v-if="checkForm.exppower == 1 && linkedStoreList.length>0 && selectedDeliveryStore && selectedDeliveryStore.flowcode">
                <a href="javascript:;">
                  <img v-if="selectedDeliveryStore.mainpiclink" :src="selectedDeliveryStore.mainpiclink">
                  <img v-else src="https://presale.jhtsoft.com/picms/c47499b67d489.png">
                  <em class="obliqueLabel" v-if="selectedDeliveryStore.flowcode == userInfoMd.flowcode">当前门店</em>
                </a>
                <div>
                  <p class="textHiden" :title="selectedDeliveryStore.flowname"><el-tag type="danger" plain v-if="!selectedDeliveryStore.status">已禁用</el-tag>{{selectedDeliveryStore.flowname}}</p>
                  <p class="greyColor" v-if="selectedDeliveryStore.linkman || selectedDeliveryStore.mobile || selectedDeliveryStore.tel">{{selectedDeliveryStore.linkman}} {{selectedDeliveryStore.mobile?selectedDeliveryStore.mobile:selectedDeliveryStore.tel}}</p>
                  <p class="greyColor" v-if="selectedDeliveryStore.province || selectedDeliveryStore.city || selectedDeliveryStore.district || selectedDeliveryStore.addrdet">{{selectedDeliveryStore.province}} {{selectedDeliveryStore.city}} {{selectedDeliveryStore.district}} {{selectedDeliveryStore.addrdet}}</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!--E 基本信息表单-->
      <div class="bottomBtn" >
        <el-button type="primary" v-if="operate != 'detail'" @click="saveFlow" :loading="isLoad">提交</el-button>
        <el-button :type="operate == 'detail' ? 'primary' : ''" @click="$router.back(-1)">返回</el-button>
      </div>
    </section>

    <!-- S 绑定门店 -->
    <StoreChose :chosestoreDatas="objectType==100?selectedDeliveryStore:linkedStoreList" :totalList="linkedStoreList" :needFirstStore="1" :objectType="objectType" :isSinglesel="isSinglesel" :currentflowcode="flowcode" :storeChoseDialogVisible="storeChoseDialogVisible" @closeChild="getCloseStoreCldd" @chosestoreData="chosestoreData"></StoreChose>
    <!-- E 绑定门店 -->
    
  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'CompanyStoreOperate',
  data () {
    let that=this;
    return {
        operate:this.$route.params.operate,//父级页面传来的操作
        flowcode:this.$route.query.flowcode,//企业微门店编号
        qydm:'',//企业代码
        currentTit:0, //当前选中菜单
        checkForm:{
          flowname:'',//企业微门店名称
          status:true,//服务状态
          linkman:'',//联系人
          sex:2,//性别
          birthday:'',//生日
          mobile:'',//手机号
          tel:'',//座机
          email:'',//邮箱
          pcdinfo:[],//地址
          addrdet:'',//详细地址
          memo:'',//备注
          cardpower:0,//券卡权限、激活权限
          orderpower:0,//订单权限、核销权限
          exppower:0,//发货权限
        }, //表单
        rules: {
            flowname: [
                { required: true, message: '企业微门店名称不能为空'},
                { min: 0, max: 20, message: '长度必须在 0 到 20 之间', trigger: 'blur' }
            ],
            linkman: [
                { required: true, message: '联系人不能为空'}
            ],
            pcdinfo: [
                { required: true, message: '地址不能为空'}
            ],
            addrdet: [
                { required: true, message: '详细地址不能为空'},
                { min: 5, max: 50, message: '长度必须在 5 到 50 之间', trigger: 'blur' }
            ],
            mobile: [ //手机号码
                { 
                    validator(rule,value,callback){
                        if(that.telCheck(value,1) === 2){
                            callback(new Error("请输入合法的手机号码！"));
                        }else{
                          callback();
                        }
                    },
                    trigger: "blur" 
                },
            ],
            tel: [ //固话号码
                { 
                    validator(rule,value,callback){
                        if(that.telCheck(value,2) === 2){
                            callback(new Error("请输入合法的固话号码！"));
                        }else{
                          callback();
                        }
                    },
                    trigger: "blur" 
                },
            ],
            email: [ //电子邮箱
                { 
                    validator(rule,value,callback){
                        if(that.emailCheck(value) === 2){
                            callback(new Error("请输入合法的电子邮箱！"));
                        }else{
                          callback();
                        }
                    },
                    trigger: "blur" 
                },
            ],
        },
        otherSetting:false, //其他设置默认隐藏
        isLoad:false,//加载中

        linkedStoreList:[],//已绑定的门店
        totalList:[],//绑定门店
        objectType:9,//9：查二级门店列表，100：单选勾选发货门店，查已选门店（包含二级和一级）
        isSinglesel:0,//1:单选  0：多选
        flowcodes:'',//已绑定微门店编号
        storeChoseDialogVisible:false,
        selectedDeliveryStore:{},//选中的发货门店
        userInfoMd:{},//一级门店信息
      }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    ProvincesOrCity: resolve =>require(["@/components/common/ProvincesOrCity.vue"], resolve),//省市区选择
    StoreChose: resolve =>require(["@/components/CardsFolder/StoreChose.vue"], resolve), //选择微门店
  },
  methods: {
    //----------------------------------------绑定二级门店相关 zly  2024.7.31  Start------------------------
    // table的背景色
    tableRowClassName({row, rowIndex}) {
      if (!row.status) {
        return 'redBg';
      }
      return '';
    },
    //获取当前微门店已绑定的门店列表
    haveLinkedStores(flowcode){
      let params = {
        type:1, //查询微门店绑定的门店列表
        flowcode:flowcode
      };
      api.GETBINDWXFLOW(params).then(res => {
        if(res.data.status == '200'){
          if(res.data.data && res.data.data != 'null'){
            let allBindList = res.data.data;
            let onStoreArr = [];//启用列表
            let stopStoreArr = [];//禁用列表
            let codesarr = [];//存编号
            allBindList.map(item => {
              if(item.status){
                onStoreArr.push(item)
              }else{
                stopStoreArr.push(item)
              }

              if(item.havedelivery == 1){
                this.selectedDeliveryStore = item;
              } 
              codesarr.push(item.flowcode);
            })
            this.linkedStoreList = [...onStoreArr, ...stopStoreArr];//合并启用、禁用
            this.flowcodes = codesarr.join(',');
          }
        }
      }).catch()
    },
    //一键清空重选
    deleteAll(){
      this.$confirm(`清除所有绑定门店，重新选择？`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        // dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.linkedStoreList = [];
        this.flowcodes = '';
        // this.linkAllStores(9)
      }).catch();
    },
    //移除绑定门店
    deleteStore(flowcode,index){
      if(this.selectedDeliveryStore && this.selectedDeliveryStore.flowcode && flowcode == this.selectedDeliveryStore.flowcode){
        this.$confirm(
          `删除该门店将<i class="redColor">解除</i>当前微门店<i class="redColor">为其发货的权限</i>，确认删除？`,
          "提示",
          {
            // confirmButtonText: "确认删除",
            // cancelButtonText: "放弃删除",
            type: "warning",
            // customClass:'wideBtnMsg',
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          this.checkForm.exppower = 0;
          this.selectedDeliveryStore = {};

          this.linkedStoreList.splice(index,1);
          let codesarr = this.flowcodes.split(',');
          codesarr.splice(index,1);
          this.flowcodes = codesarr.join(',');
        }).catch();
      }else{
        this.linkedStoreList.splice(index,1);
        let codesarr = this.flowcodes.split(',');
        codesarr.splice(index,1);
        this.flowcodes = codesarr.join(',');
      }
    },
    //9:绑定门店 100:选择发货门店
    linkAllStores(type){
      this.objectType = type;
      if(type == 100){
        this.isSinglesel = 1;
      }else{
        this.isSinglesel = 0;
      }
      this.storeChoseDialogVisible = true;
    },
    // 关闭选择绑定门店弹窗
    getCloseStoreCldd() {
      this.storeChoseDialogVisible = false;
    },
    //已绑定微门店数据
    chosestoreData(type){
      if(this.isSinglesel != 1){
        let onStoreArr = [];//启用列表
        let stopStoreArr = [];//禁用列表
        let parm ='';
        if(type.length>0){
          type.map((item,index) => {
            if(item.status){
              onStoreArr.push(item)
            }else{
              stopStoreArr.push(item)
            }

            if(index!=0){
              parm += ',';
            }
            parm += item.flowcode;
          })
        }
        this.flowcodes = parm;
        this.linkedStoreList = [...onStoreArr, ...stopStoreArr];//合并启用、禁用
        console.log(this.flowcodes,'已选的编号列表')
        //更改绑定门店后，如果取消了发货门店，需清空发货编号
        if(this.selectedDeliveryStore && this.selectedDeliveryStore.flowcode){
          if(!this.flowcodes.includes(this.selectedDeliveryStore.flowcode)){
            this.checkForm.exppower = 0;
            this.selectedDeliveryStore = {};
          }
        }
        if(this.linkedStoreList.length==0){
          this.checkForm.cardpower = 0;
        }
      }else{
        this.selectedDeliveryStore = type;
      }
    },
    //----------------------------------------绑定二级门店相关 zly-2024.7.31  End------------------------
    // 流向名称重复性校验
    checkFlowname(){
        if(this.checkForm.flowname){
            let params = {
                flowname:this.checkForm.flowname,
								objtype:4,
            }
            if(this.flowcode){
                params.flowcode = this.flowcode
            }
            api.CHECKFLOWNAME(params).then((res) => {
                if(res.data.data){
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })
        }
    },
    // 切换状态
    statusChange(val){
        this.checkForm.status = val;
    },
    // 获取详情
    getFlowDetail(){
        this.isLoad = true;
        api.GET_FLOWDETAIL({flowcode:this.flowcode}).then((res) => {
            if(res.data.status == "200"){
                this.isLoad = false;
                this.checkForm = res.data.data;
				        this.checkForm.birthday = this.dateTime(this.checkForm.birthday)
                this.checkForm.pcdinfo = [{
                    name: res.data.data.province,
                    code: res.data.data.provincecode
                },
                {
                    name: res.data.data.city,
                    code: res.data.data.citycode
                },
                {
                    name: res.data.data.district,
                    code: res.data.data.districtcode
                }];
            }else{
                this.$message.error('获取详情信息失败！')
            }
        })
    },
    // 提交
    saveFlow(){
        if(!this.checkForm.flowname){
            this.$message.error('企业微门店名称不能为空！');
            return false
        }
        if(!this.checkForm.pcdinfo || this.checkForm.pcdinfo.length == 0){
            this.$message.error('企业微门店地址不能为空！');
            return false
        }
        if(this.checkForm.addrdet == ''){
            this.$message.error('详细地址不能为空！');
            return false
        }
        if(this.checkForm.addrdet){
            if(this.checkForm.addrdet.length < 5 || this.checkForm.addrdet.length > 50){
                this.$message.error('详细地址长度必须在 5 到 50 之间');
                return false
            }
        }
        if(!this.checkForm.linkman){
            this.$message.error('联系人不能为空！');
            return false
        }
        if(!this.checkForm.mobile && !this.checkForm.tel){
            this.$message.error('手机号码和固话号码至少填写一个！');
            return false
        }
        if(this.checkForm.mobile){
            if(this.telCheck(this.checkForm.mobile,1) === 2){
                this.$message.error("请输入合法的手机号码！");
                return false
            }
        }
        if(this.checkForm.tel){
            if(this.telCheck(this.checkForm.tel,2) === 2){
                this.$message.error("请输入合法的固话号码！");
                return false
            }
        }
        if(this.checkForm.email){
            if(this.emailCheck(this.checkForm.email) == 2){
                this.$message.error("请输入合法的电子邮箱！");
                return false
            }
        }
        if(this.ElementControls('erjimendian')==1) {
          if(this.checkForm.exppower && !(this.selectedDeliveryStore && this.selectedDeliveryStore.flowcode)){
            this.$message.error("已勾选发货权限，请选择需要发货服务的门店！");
            return false
          }
        }
        let params = {
            addtype:0,//0：完整新增 1：精简新增
            flowname:this.checkForm.flowname,
            objtype:4,//0:门店；1：发货网点；2：一级分销；4：微门店；5：企业微门店；
            status:this.checkForm.status ? 1 : 0,
            linkman:this.checkForm.linkman,
            sex:Number(this.checkForm.sex),
            birthday:this.checkForm.birthday,
            mobile:this.checkForm.mobile,
            tel:this.checkForm.tel,
            email:this.checkForm.email,
            provincecode:this.checkForm.pcdinfo[0].code,
            province:this.checkForm.pcdinfo[0].name,
            citycode:this.checkForm.pcdinfo[1].code,
            city:this.checkForm.pcdinfo[1].name,
            districtcode:this.checkForm.pcdinfo[2].code,
            district:this.checkForm.pcdinfo[2].name,
            addrdet:this.checkForm.addrdet,
            memo:this.checkForm.memo,
        }
        if(this.ElementControls('erjimendian')==1){
          if(this.checkForm.exppower != 1){
            this.selectedDeliveryStore = {};
          }
          params.cardpower = this.checkForm.cardpower;
          params.orderpower = this.checkForm.orderpower;
          params.exppower = this.checkForm.exppower;
          params.bindflowcodes = this.flowcodes;
          params.deliveryflowcode = (this.checkForm.exppower && this.selectedDeliveryStore && this.selectedDeliveryStore.flowcode) ? this.selectedDeliveryStore.flowcode : '';
        }
        if(this.operate == 'edit'){
            params.flowcode = this.flowcode
        }
        this.isLoad = true;
        api.SAVEFLOW(params).then((res) => {
            if(res.data.status == "200"){
                this.$message.success(res.data.message);
                this.$router.push({
                    path:'/CompanyStore'
                })
            }else{
                this.$message.error(res.data.message);
            }
            this.isLoad = false;
        })
    },
  },
  created() {
    
  },
  mounted(){
    // 获取企业代码
    let cmpyinfo = localStorage.getItem("cmpyinfo");
    if(cmpyinfo && cmpyinfo != 'null' && cmpyinfo != 'undefined'){
        this.qydm = JSON.parse(cmpyinfo).qydm;
    }
    if(this.operate != 'add'){
      this.getFlowDetail();//获取详情
      if(this.ElementControls('erjimendian')==1){
        this.haveLinkedStores(this.flowcode);//获取当前微门店已绑定的门店列表
      }
      if(this.$refs.checkForm){
        this.$refs.checkForm.resetFields();
      }
    }
    if(this.ElementControls('erjimendian')==1){
      if (localStorage.getItem('userInfoMd')) {
        this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      }
    }

    
    
  },
}
</script>
<style scoped>
/* @import '../../GoodsFolder/Css/style.css'; */
@import '../Css/style.css';
.mainDet{height:calc(100vh - 155px)!important;}
/* .mainWrap{width: 80%!important;} */
/* S 点击展开其他设置 */
.expandTarget {position:relative;font-size: 12px; color:#999; cursor: pointer;}
.expandTarget b {color:var(--main-color);}
.expandTarget:before {position: absolute; left:110px; -webkit-transition:transform .2s;-moz-transition:transform .2s;-ms-transition:transform .2s;-o-transition:transform .2s; transition:transform .2s;top: 0;bottom: 0;margin: auto;height: 40px;}
.expandTarget.on:before {-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);}
/* E 点击展开其他设置 */
.otherSetInfo {max-height:0; overflow:hidden; -webkit-transition:max-height .2s;-moz-transition:max-height .2s;-ms-transition:max-height .2s;-o-transition:max-height .2s;transition:max-height .2s;}
.otherSetInfo.expanded {max-height: 300px;}
.fixNum {
  width:100%;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 10px;
  -webkit-box-sizing:  border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
}
.fixBg{
  background: #F5F7FA;
}
.fixNum .el-input {
  display: inline-block;
  width: 80%;
}
.fixNum>>>.el-input__inner {
  border: none;
  border-radius: 0;
  padding-left: 5px;
}
.fixNum span {
  color: #333;
}
/* .comForm{padding-top:64px;} */

/*权限设置 */
.comTable.el-table--border >>>.redBg {background: #FEF7F7;}
.comTable>>>.el-table__body tr.hover-row.redBg>td {background: #FEF7F7!important;}

.powerLine {padding:10px 0;}
.mlineBox {margin:10px auto;}
.pb10 {padding-bottom:10px;}

.storeInfo a{width:60px;height:60px;position:relative;border:solid 1px #ebeeeb;box-sizing:border-box;margin-right:10px;overflow: hidden;}
.storeInfo a img{max-width:100%;max-height:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}
.storeInfo .obliqueLabel {position:absolute;top:4px; left:-30px;display:inline-block;padding:0 20px; font-size: 12px; line-height: 20px; background:#5db830; color: #fff; white-space: nowrap; transform: rotate(-45deg) scale(0.7);}
.storeInfo div{flex:0 0 calc(100% - 70px);max-width:calc(100% - 70px);text-align:left}
.storeInfo div p {line-height: 25px;}
.addDetail i{color:#f2962c;font-size:18px;-o-align-self:flex-start;-ms-align-self:flex-start;-moz-align-self:flex-start;-webkit-align-self:flex-start;align-self:flex-start}
.addDetail p{width:100%}


.storeEm{color:#999;font-size:12px;cursor:pointer;margin-left:5px}
.storeEm b{font-weight:700;color:#f7615e;margin:0 5px;font-size:14px}
.bannerBg{background: #f5f5f5;padding: 15px 20px;margin-bottom:20px;width: calc(50% - 40px);min-width: 550px;}
.bannerBg .el-button {margin-left:25px;}
.bannerBg .storeInfo {background:#fff; box-shadow: 0 2px 12px rgba(0,0,0,.1); max-width:450px; padding:15px;}
.bannerBg .storeInfo a {width:80px;height:80px;}
.bannerBg.storeInfo div{flex:0 0 calc(100% - 90px);max-width:calc(100% - 90px);}
.bannerBg .el-form-item:last-child{margin-bottom:0;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/CompanyStoreOperate.vue